<template>
	<div class="cloud-container">
		<div class="cloud-header-top">
			<div v-for="(bubble, index) in bubbleContainers" :key="index" class="bubbles"
				:style="{ position: 'relative', overflow: 'hidden' }">
				<!-- 动态生成的气泡 -->
				<span v-for="(particle, i) in bubble.particles" :key="i" class="particle"
					:style="particle.style"></span>

				<!-- 这里可以放你的文字内容 -->
				<slot></slot>
			</div>

			<div class="line-container" style="top: 16px;">
				<div class="stretch-line left-line"></div>
				<div class="stretch-line right-line"></div>
			</div>
			<div class="line-container" style="top: 53px;">
				<div class="stretch-line left-line"></div>
				<div class="stretch-line right-line"></div>
			</div>

			<div class="line-container" style="top: 68px;">
				<div class="stretch-line center-line"></div>
			</div>
			<ul class="menu-lists">
				<li :class="{ 'active': activeIndex === 0 }" @click="activeClick(0, '项目概况')" v-if="projecTenusData.filter(item => item.menuName === '项目概况').length === 1"><img
						src="@/assets/images/home.png" />
					<p>首页</p>
				</li>
				<li :class="{ 'active': activeIndex === 1 }" @click="activeClick(1, '人机管理')" v-if="projecTenusData.filter(item => item.menuName === '人机管理').length === 1"><img
						src="@/assets/images/safety.png" />
					<p>人机管理</p>
				</li>
				<li :class="{ 'active': activeIndex === 2 }" @click="activeClick(2, '平安守护')" v-if="projecTenusData.filter(item => item.menuName === '项目概况').length === 1"><img
						src="@/assets/images/safeSound.png" />
					<p>平安守护</p>
				</li>
				<li :class="{ 'active': activeIndex === 3 }" @click="activeClick(3, '安全帽管理')" v-if="projecTenusData.filter(item => item.menuName === '安全帽管理').length === 1"><img
						src="@/assets/images/safeSound.png" />
					<p>安全帽管理</p>
				</li>
				<li :class="{ 'active': activeIndex === 4 }" @click="activeClick(4, '智能工装')" v-if="projecTenusData.filter(item => item.menuName === '智能工装').length === 1"><img
						src="@/assets/images/safety.png" />
					<p>智能工装</p>
				</li>
				<li :class="{ 'active': activeIndex === 5 }" @click="activeClick(5, '工程管理')" v-if="projecTenusData.filter(item => item.menuName === '工程管理').length === 1"><img
						src="@/assets/images/engineering.png" />
					<p>工程管理</p>
				</li>
				<li style="margin-right: 0px;" :class="{ 'active': activeIndex === 6 }" @click="activeClick(6, '党建管理')" v-if="projecTenusData.filter(item => item.menuName === '党建管理').length === 1">
					<img src="@/assets/images/archive.png" />
					<p>党建管理</p>
				</li>
				<li style="width: calc(120 / 1920 * 100vw)">
					<img src="@/assets/images/wanret.png" alt="" style="width: 50px; height: 50px; border-radius: 50%; margin-top: 10px; 
				right: calc(100 / 1920 * 100vw); cursor: pointer; z-index: 999; cursor: pointer; position: absolute;"
						@click="showWanret = true">
					<p
						style="width: 20px; height: 20px; cursor: pointer; color: dimgrey; position: absolute; top: 3px; right: calc(105 / 1920 * 100vw); color: red; font-weight: bold;">
						{{ wamingNum }}</p>
					<p style="width: 50px; height: 30px; line-height: 30px; cursor: pointer; color: dimgrey; font-size: 0.9rem; color: #999; z-index: 999;  position: absolute; top: 3px; right: calc(45 / 1920 * 100vw);"
						@click="logout">退出</p>
					<!-- <p style="width: 150px; height: 2vh; line-height: 9vh; margin-right: -50px; z-index: 999; font-size: 1.2vh; float: right; color: dimgrey;" >{{ times }}</p> -->
				</li>
			</ul>

			<ul class="menu-lists-chid"
				v-if="projecTenusData.filter(item => item.menuName === activeMenuName)[0]?.children !== null">
				<li for="item"
					v-for="item in projecTenusData.filter(item => item.menuName === activeMenuName)[0]?.children"
					:key="item.menuValue" :class="{ 'menu-item-active': activeMenuValue === item.menuValue }"
					@click="handleRouterClick(item.menuValue)">{{ item.menuName }}</li>
				<li>&nbsp;</li>
			</ul>
		</div>
		<router-view style="z-index: 998;"></router-view>
		<!-- <div class="cloud-footer">
			<p>@2025 广东咏思隧道 版权所有</p>
		</div> -->

		<div class="wanret_div" v-if="showWanret">
			<div>数据阈值下限告警 </div>
			<div>
				<div><img src="@/assets/images/wanret.png" alt="" /></div>
				<div>
					<p>报警时间：<span>{{ alarmTime }}</span></p>
					<p>报警类型：<span>{{ alarmType }}</span></p>
					<p>安装位置：<span>{{ alarmPosition }}</span></p>
					<p>设备名称：<span>{{ alarmDevice }}</span></p>
				</div>
			</div>
			<div>
				<el-button size="small" @click="showWanret = false">关闭</el-button>
				<el-button type="primary" size="small">下一个</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { projectenus } from '@/public/api.js'
import { getIndex } from '@/public/apiCapsRundePro.js'
import { getRandomNumber } from '@/utils/index.js'

// 引入路由实例
export default {
	name: 'loginpage',
	components: {
	},
	data() {
		return {
			wamingNum: 0,
			activeIndex: 0,
			activeMenuValue: '',
			activeMenuName: '项目概况',
			times: '',
			showWanret: false,
			alarmTime: '2025-01-01 00:00:00',
			alarmType: '数据阈值下限告警',
			alarmPosition: '隧道入口',
			alarmDevice: '数据采集器',
			projecTenusData: [],
			bubbleContainers: [] // 存储每个容器的气泡数据
		}
	},
	computed: {

	},
	mounted() {
		// let that = this;
		// setInterval(() => {
		// 	that.times = new Date().toLocaleString();
		// }, 1000);
		let that = this;
		that.projecTenusData = JSON.parse(localStorage.getItem('projecTenusData')) || [];
		that.transferDepartmentListData = JSON.parse(localStorage.getItem('transferDepartmentListData')) || [];
		if (that.projecTenusData === null || that.projecTenusData.length === 0) {
			projectenus({ itemId: that.transferDepartmentListData[0].itemId, type: "tunnel" }).then(res => {
				if (res.data.code === 200) {
					localStorage.setItem('projecTenusData', JSON.stringify(res.data.data)); // 序列化存储
					that.projecTenusData = res.data.data;
				}
			})
		}
		this.initBubbles();

		
		// 监听页面加载完成（确保所有资源加载完毕后再判断）
		window.onload = () => {
			this.judgePageOpenType();
		};

		// 监听页面刷新前（可选，强化标记的准确性）
		window.onbeforeunload = () => {
			// 刷新前无需删除标记，sessionStorage 会保留在当前会话中
			sessionStorage.setItem('pageHasLoaded', 'true');
		};
	},
	methods: {
		async activeClick(index, menuName) {
			let that = this;
			let TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));
			if (TunnelsData === null || TunnelsData === undefined) {
				localStorage.setItem('updateLhTunnels', JSON.stringify({
					"itemName": "咏思单洞隧道斜井",
					"itemId": 28,
					"itemAddr": "广东省佛山市南海区桂城街道",
					"planBeginDate": "2025-10-01",
					"planCompleteDate": "2026-10-01",
					"itemTunnelType": "3",
					"status": "进场"
				}));
				return;
			}

			this.activeIndex = index;
			this.activeMenuName = menuName;

			if (index === 6) {
				this.activeMenuValue = 'partyBuilding';
				this.$router.push({
					path: '/partyBuilding?id=' + getRandomNumber(100000, 999999),
				});
			} else if (index === 3) {
				that.$alert('您好，安全帽管理功能暂未开放，正在建设中！', '温馨提示', {
					confirmButtonText: '确定',
					callback: action => {
						
					}
				});
				// let getIndexData = await getIndex(null, {
				// 	ctl: 'tool',
				// 	act: 'get_pkey',
				// 	user_name: '演示100901',
				// 	pwd: 'SDys@yanshi1009'
				// })

				// if (getIndexData.data.msg === 'success') {
				// 	let getIndexPkeyData = await getIndex(null, {
				// 		ctl: 'tool',
				// 		act: 'get_token',
				// 		user_name: '演示100901',
				// 		pkey: getIndexData.data.data
				// 	})

				// 	if (getIndexPkeyData.data.status === true) {
				// 		that.$cookies.set('updateCapsRundeProToken', getIndexPkeyData.data.session_id)
				// 		let stxtg = 'https://47.105.85.239:10006/login#token=' + this.$cookies.get("updateCapsRundeProToken") + '&user_name=济枣二标&target=home'
				// 		const newWindow = window.open(stxtg, '_blank');
				// 		if (newWindow) {
				// 			newWindow.focus();
				// 		}
				// 	}
				// }
			} else {
				this.handleRouterClick(this.projecTenusData.filter(item => item.menuName === this.activeMenuName)[0]?.children[0]?.menuValue)
			}
		},
		handleRouterClick(menuValue) {
			let TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));
			if (TunnelsData === null || TunnelsData === undefined) {
				this.$message({
					message: '警告，您好，请先选择隧道项目！',
					type: 'warning'
				});
				return;
			}

			this.activeMenuValue = menuValue;
			this.$router.push({
				path: '/' + menuValue + '?id=' + getRandomNumber(100000, 999999),
			});
		},
		logout() {
			// 清除登录状态
			localStorage.removeItem('showHome');
			localStorage.removeItem('transferDepartmentListData');
			localStorage.removeItem('updateLhTunnels');
			localStorage.removeItem('updateToken');
			localStorage.removeItem('updateTokenPass');
			localStorage.removeItem('updateTunnelDeptId');
			localStorage.removeItem('updateTunnelItemId');
			localStorage.removeItem('updateTunnelNumber');
			localStorage.removeItem('projecTenusData');
			this.$router.push('/login');
		},
		// 生成 min 到 max 之间的随机数（包含 min，不包含 max）
		rnd(min, max) {
			return Math.random() * (max - min) + min;
		},

		initBubbles() {
			// 假设你页面中有 N 个 .particletext.bubbles 元素
			// 这里我们用 this.$refs.bubbles 获取（需确保在 mounted 后）
			this.$nextTick(() => {
				const containers = [];

				const width = 0;
				const particles = [];

				for (let i = 0; i <= 100; i++) {
					const size = this.rnd(40, 80) / 10; // 4 ~ 8
					const style = {
						position: 'absolute',
						top: `${this.rnd(20, 80)}%`,
						left: `${this.rnd(0, 95)}%`,
						width: `${size}px`,
						height: `${size}px`,
						animationDelay: `${this.rnd(0, 30) / 10}s`,
						// 可加背景色或 border-radius 让气泡可见
						backgroundColor: 'rgba(255, 255, 255, 0.3)',
						borderRadius: '50%',
						pointerEvents: 'none'
					};
					particles.push({ style });
				}

				containers.push({ particles });
				this.bubbleContainers = containers;
			});
		},
		judgePageOpenType() {
			// 步骤1：获取 sessionStorage 中的已加载标记
			const pageHasLoaded = sessionStorage.getItem('pageHasLoaded');

			// 步骤2：判断打开方式
			if (pageHasLoaded === 'true') {
				// 存在标记 → 普通刷新
				// console.log('当前页面是：普通刷新（F5/刷新按钮）');
				// this.$message?.info('当前页面是：普通刷新（F5/刷新按钮）'); // 可选，结合Element UI提示
			} else {
				// 不存在标记 → 首次加载（收藏夹打开/新标签页/直接输入网址）
				// console.log('当前页面是：首次加载（大概率是收藏夹打开）');
				// this.$message?.info('当前页面是：首次加载（大概率是收藏夹打开）'); // 可选，结合Element UI提示
				// 步骤3：写入标记，为后续刷新做准备
				sessionStorage.setItem('pageHasLoaded', 'true');
				// 清除登录状态
				localStorage.removeItem('showHome');
				localStorage.removeItem('transferDepartmentListData');
				localStorage.removeItem('updateLhTunnels');
				localStorage.removeItem('updateToken');
				localStorage.removeItem('updateTokenPass');
				localStorage.removeItem('updateTunnelDeptId');
				localStorage.removeItem('updateTunnelItemId');
				localStorage.removeItem('updateTunnelNumber');
				localStorage.removeItem('projecTenusData');
				this.$router.push('/login');
			}
		}
	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
/* 定义快速闪烁动画 */
@keyframes fastBlink {
	0% {
		visibility: visible;
	}

	50% {
		visibility: hidden;
	}

	100% {
		visibility: visible;
	}
}

/* 应用动画 */
.fast-blinking-tooltip {
	/* 使用更短的动画时长 */
	animation: fastBlink 0.5s step-end infinite;
}

.cloud-container {
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	>.cloud-header-top {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: auto;
		z-index: 1;

		>.line-container {
			position: absolute;
			width: 100vw;
			/* 占满视口宽度 */
			height: 1px;
			z-index: 1;

			>.stretch-line {
				width: 10px;
				height: 100%;
				background-color: #97bcf0;
				top: 0px;
				/* 垂直对齐容器 */
				position: absolute;
				/* 精准定位左右线条 */
			}

			/* 左侧线条：定位在容器左侧 */
			>.left-line {
				right: calc(50vw + 350px);

			}

			/* 右侧线条：定位在容器右侧 */
			>.right-line {
				left: calc(50vw + 190px);
			}

			/* 中心线条：定位在容器中心 */
			>.center-line {
				left: 47%;
				transform: translateX(-50%);
			}

		}

	}

	>.cloud-footer {
		position: absolute;
		bottom: 2vh;
		left: 0;
		width: 100%;
		height: 5vh;
		color: #fff;
		text-align: center;
		line-height: 5vh;
	}

	.wanret_div {
		position: absolute;
		top: 7vh;
		right: 240px;
		width: 350px;
		height: 25vh;
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 10px;
		padding: 0px;
		font-size: 0.8rem;
		z-index: 999;
		background-color: #283F65;

		>div {
			margin: 0px;
			padding: 0px;
		}

		>div:nth-child(1) {
			font-size: 0.9rem;
			font-weight: bold;
			color: #fff;
			margin-bottom: 1.52vh;
			background-image: url('@/assets/images/groupTitle.png');
			background-repeat: no-repeat;
			background-position: left center;
			width: 100%;
			height: 5vh;
			line-height: 5vh;
			text-align: left;
			text-indent: 30px;
		}

		>div:nth-child(2) {
			width: 100%;
			height: 13vh;

			>div {
				height: 12vh;
				margin: 0px;
				padding: 0px;
			}

			>div:nth-child(1) {
				width: 35%;
				float: left;

				>img {
					width: 90px;
					height: auto;
					cursor: pointer;
					border: 1px dashed #4c4c49;
					margin: 0 auto;
				}
			}

			>div:nth-child(2) {
				width: 64%;
				float: right;
				text-align: left;
				height: 11vh !important;

				>p {
					margin: 0px;
					padding: 0px;
					height: 2.7vh;
					line-height: 2.7vh;
				}
			}
		}
	}

	.menu-lists {
		position: relative;
		width: 100%;
		height: calc(69 / 1960 * 100vw);
		/* 与背景图高度一致 */
		padding: 0;
		margin-top: -200px;
		/* 保留你的偏移 */
		list-style: none;
		z-index: 9997;
		background: url(@/assets/images/topbg.png) no-repeat center top / 100% auto;
		/* 关键：高度 auto 保持比例 */
		font-size: 12px;


		>li {
			margin: 0px;
			padding: 0px;
			width: calc(130 / 1920 * 100vw);
			height: 100%;
			margin-right: calc(20 / 1080 * 100vh);
			float: left;
			line-height: normal;
			/* 不再用固定 line-height */
			text-align: center;
			color: #fff;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			>img {
				width: 15px;
				height: auto;
				margin-right: 5px;
				float: left;
				margin-left: calc(30 / 1920 * 100vw);
			}

			>p {
				font-size: 12px;
				width: 55%;
				text-align: left;
				float: left;
			}

			&.active {
				color: #FFD700;
			}

			&:hover p {
				color: #f0a309;
				/* 鼠标悬停时的文字颜色，可自定义 */
			}
		}

		>li:nth-child(1) {
			margin-left: calc(180 / 1920 * 100vw);
		}

		>li:nth-child(4) {
			margin-left: calc(555 / 1920 * 100vw);
		}

	}

	.menu-lists-chid {
		display: flex;
		justify-content: center;
		padding: 0;
		margin: 0;
		list-style: none;
		width: 98.8%;
		margin: 0 auto;
		/* 使用 rgba 设置背景半透明，不影响子元素 */
		/* background: linear-gradient(to right,
				rgba(21, 157, 241, 0.4),
				rgba(84, 176, 233, 0.4),
				rgba(58, 168, 236, 0.4));*/

		border-bottom: 2px solid rgb(22, 107, 163);
		z-index: 999;
		position: relative;
	}

	.menu-lists-chid>li {
		margin: 0;
		padding: 0;
		width: 200px;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #fff;
		cursor: pointer;
		font-size: 14px;


		&:hover {
			color: #f0a309;
			/* 鼠标悬停时的文字颜色，可自定义 */
		}
	}

	.menu-lists-chid>li.menu-item-active {
		color: #FFD700;
	}

	.menu-item-active {
		color: hsl(59, 91%, 48%) !important;
	}
}
</style>

<!-- 动画相关样式放在非 scoped 中，避免关键帧被隔离 -->
<style>
.left-line {
	/* 绑定动画：动画名称、时长、线性变化、无限循环 */
	animation: stretchToBothSidesLeft 2s linear infinite;
}

.right-line {
	/* 绑定动画：动画名称、时长、线性变化、无限循环 */
	animation: stretchToBothSidesRight 2s linear infinite;
}

.center-line {
	/* 绑定动画：动画名称、时长、线性变化、无限循环 */
	animation: stretchToBothSidesCenter 2s linear infinite;
}

/* 关键帧动画定义 */
@keyframes stretchToBothSidesCenter {
	0% {
		width: 10px;
	}

	100% {
		width: 20%;
	}
}

/* 关键帧动画定义 */
@keyframes stretchToBothSidesLeft {
	0% {
		width: 10px;
	}

	100% {
		width: calc(50vw - 550px);
	}
}

/* 关键帧动画定义 */
@keyframes stretchToBothSidesRight {
	0% {
		width: 10px;
	}

	100% {
		width: calc(50vw - 650px);
	}
}

.cloud-header-top>.bubbles {
	width: 100%;
	height: 200px;
	position: absolute;

	>.particle {
		opacity: 0;
		position: absolute;
		background-color: rgba(33, 150, 243, 0.5);
		animation: bubbles 3s ease-in infinite;
		border-radius: 100%;
	}
}

@keyframes bubbles {
	0% {
		opacity: 0;
	}

	20% {
		opacity: 1;
		transform: translate(0, -20%);
	}

	100% {
		opacity: 0;
		transform: translate(0, -1000%);
	}
}
</style>